import React from 'react';
import Slider from "./Slider";
import styled from "styled-components";
import InformationBlock from "./InformationBlock";
import FormBlock from "./FormBlock";

const Body: React.FC = () => {

    return (
        <Container>
            <H2>Codes</H2>
            <P>Already know the code? try entering</P>
            <FormBlock/>
            <P>Here are your codes.<br/>
                For missing ones, ask our community.</P>
            <Slider/>
            <InformationBlock/>
        </Container>
    );
};

export default Body;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    overflow-y: scroll;
`;
const H2 = styled.h2`
    padding: 0 24px;
    font-size: 32px;
    font-weight: 700;
    margin: 24px 0 5px;
    opacity: .7;
`;
const P = styled.p`
    font-size: 16px;
    font-weight: 700;
    opacity: .7;
    margin: 0;
    padding: 0 24px;
`
